export default "__VITE_ASSET__pviHWXzW__"